<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.积分组编辑") }}</span>
    </div>

    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>

    <div class="grid-content subtitle">
      <span>{{ $t("message.积分组信息") }}</span>
    </div>
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr v-if="pointGroup.groupid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.积分分组ID") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGroup.groupid"
              readonly
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.积分分组名称") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="pointGroup.name"
              type="textarea"
              :placeholder="$t('message.请输入产品名称')"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.状态") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="pointGroup.state">
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <el-radio :label="1">{{ $t("message.禁用") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.类型") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGroup.type"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in groupTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">icon</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(1)"
            >
              <i class="iconfont" v-if="!pointGroup.icon">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="pointGroup.icon"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="pointGroup.icon" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="pointGroup.icon = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.积分规则说明") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="pointGroup.info"
              type="textarea"
              :placeholder="$t('message.请输入积分规则说明')"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.有效期类型") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGroup.expiretype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in expireTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="pointGroup.expiretype > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.有效期参数") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGroup.expireparam"
              :placeholder="$t('message.请输入有效期参数')"
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.是否有获取上限") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="toplimitType"
              :placeholder="$t('message.请选择')"
              @change="onChangeToplimitType"
              style="width: 175px"
            >
              <el-option
                v-for="item in toplimitTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="toplimitType > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.获取积分上限") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="pointGroup.toplimit"
              :placeholder="$t('message.请输入有效期参数')"
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;">
            <span class="simpleLabel" style="">{{ $t("message.规则详情") }}</span>
          </td>
          <td>
            <wangeditor @savereturn='saveRule' :init='initRuleDate()' :isedit='isEditMode'>
            </wangeditor >
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{
              $t("message.获取积分通知方式")
            }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGroup.getremindtype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in getRemindTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="pointGroup.getremindtype > 0">
          <td>
            <span class="simpleLabel">{{
              $t("message.获取积分消息内容")
            }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="pointGroup.getremindmsg"
              type="textarea"
              :placeholder="$t('message.请输入获取积分消息内容')"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{
              $t("message.消费积分通知方式")
            }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="pointGroup.consumeremindtype"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in consumeRemindTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr v-if="pointGroup.consumeremindtype > 0">
          <td>
            <span class="simpleLabel">{{
              $t("message.消费积分消息内容")
            }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="pointGroup.consumeremindmsg"
              type="textarea"
              :placeholder="$t('message.请输入消费积分消息内容')"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr v-if="pointGroup.groupid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGroup.createdate"
              size="mini"
              placeholder=""
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGroup.groupid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建人") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              size="mini"
              v-model="createName"
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGroup.groupid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="pointGroup.editdate"
              size="mini"
              placeholder=""
              style="width: 175px"
            />
          </td>
        </tr>
        <tr v-if="pointGroup.groupid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新人") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              size="mini"
              v-model="editName"
              style="width: 175px"
            />
          </td>
        </tr>
      </table>
    </div>

    <shade v-if="showResourceStore > 0">
      <resource-store
        :shadeShow="showResourceStore > 0"
        @onClick="onResourceStoreCallback"
        :appID="pointGroup.appid"
      ></resource-store>
    </shade>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import wangeditor from "@/components/wangeditor/wangeditor.vue"

export default {
  name: "pointGroupDetail",
  components: {
    shade,
    ResourceStore,
    wangeditor,
  },
  data() {
    return {
      tableHeight: 500,

      pointGroup: {
        appid: 188,
        groupid: 0,
        name: "",
        state: 0,
        type: 0,
        icon: "",
        info: "",
        expiretype: 0,
        expireparam: 1,
        toplimit: 1,
        rule:"",
        getremindtype: 0,
        getremindmsg: "",
        consumeremindtype: 0,
        consumeremindmsg: "",
        createdate: "",
        createid: "",
        editdate: "",
        editid: "",
      },

      groupTypeOptions: [
        {
          value: 0,
          label: "自系统内积分",
        },
        {
          value: 1,
          label: "CRM回传接口积分",
        },
      ],

      expireTypeOptions: [
        {
          value: 0,
          label: "永久有效",
        },
        {
          value: 1,
          label: "按年",
        },
        {
          value: 2,
          label: "按月",
        },
        {
          value: 3,
          label: "按天",
        },
      ],

      toplimitType: 0,
      toplimitTypeOptions: [
        {
          value: 0,
          label: "无上限",
        },
        {
          value: 1,
          label: "有上限",
        },
      ],

      getRemindTypeOptions: [
        {
          value: 0,
          label: "不通知",
        },
        {
          value: 1,
          label: "短信",
        },
        {
          value: 2,
          label: "邮件",
        },
        {
          value: 3,
          label: "微信订阅消息",
        },
      ],

      consumeRemindTypeOptions: [
        {
          value: 0,
          label: "不通知",
        },
        {
          value: 1,
          label: "短信",
        },
        {
          value: 2,
          label: "邮件",
        },
        {
          value: 3,
          label: "微信订阅消息",
        },
      ],

      createName: "",
      editName: "",

      isEditMode: true,
      isInit: true,
      showResourceStore: false,
    };
  },
  mounted: function () {
    // 用来监听el-main滚动事件
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    saveRule(rule) {
      // console.log(rule)
      if(this.isEditMode)
      {
        this.pointGroup.rule = rule;
      }
    },

    initRuleDate() {
      var body = { html: this.pointGroup.rule };
      console.log(body);
      return body;
    },

    // 监听滚动事件

    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },

    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        switch (this.showResourceStore) {
          case 1:
            this.pointGroup.icon = doc.resourceID;
            break;
        }
      }
      this.showResourceStore = 0;
    },

    goBack() {
      this.$router.go(-1); //返回上一层
    },

    doSave() {
      if (this.name == "") {
        this.$message({
          type: "error",
          message: this.$t("message.名称不能为空"),
        });
        return;
      }
      this.isEditMode = false;

      if (this.isInit)
        rejecthttp(
          true,
          "post",
          "/manage/point/createpointgroup",
          this.pointGroup,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      else {
        this.pointGroup.editdate = null;
        this.pointGroup.editid = null;
        this.pointGroup.createdate = null;
        this.pointGroup.createid = null;
        rejecthttp(
          true,
          "post",
          "/manage/point/editpointgroup",
          this.pointGroup,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      }
    },

    refresh() {
      if (!this.pointGroup.groupid) {
        return;
      }
      this.$http
        .get("/manage/point/pointgroupdetail", {
          params: {
            appid: this.pointGroup.appid,
            groupid: this.pointGroup.groupid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log("point group detail:", doc.data);
            this.pointGroup = doc.data.data;
            this.createName = doc.data.exData.datas[0].name;
            this.editName = doc.data.exData.datas[1].name;
            if (this.pointGroup.toplimit > 0) {
              this.toplimitType = 1;
            }
            this.pointGroup.createdate = commonUtil.formatDate(
              this.pointGroup.createdate
            );
            this.pointGroup.editdate = commonUtil.formatDate(
              this.pointGroup.editdate
            );
          }
        });
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },

    onChangeToplimitType() {
      this.pointGroup.toplimit = this.toplimitType;
    },
  },

  created() {
    this.pointGroup.appid = this.$route.query.appid
      ? this.$route.query.appid
      : 0;
    if (this.$route.query.id) {
      this.pointGroup.groupid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },

  computed: {},
  // // 隐藏固定栏
  // destroyed () {
  //   var topFix=document.querySelector('.topFix')
  //   // 固定栏隐藏
  //   topFix.style.display='none'
  // }
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointgroupdetail.vue